import React from 'react'

const Units_Measure = () => {
  return (
    <div className="fs-1 title-font-700">Units_Measure</div>
  )
}

export default Units_Measure